/**
 * Auth0 configuration for the application
 * This replaces the MSAL configuration during the migration
 */

export const auth0Config = {
  domain: window._env_.REACT_APP_AUTH0_DOMAIN,
  clientId: window._env_.REACT_APP_AUTH0_CLIENT_ID,
  authorizationParams: {
    redirect_uri: window._env_.REACT_APP_AUTH0_REDIRECT_URI || window.location.origin,
    audience: window._env_.REACT_APP_AUTH0_AUDIENCE,
    scope: window._env_.REACT_APP_AUTH0_SCOPE,
  },
  cacheLocation: 'localstorage',
  useRefreshTokens: true,
  useRefreshTokensFallback: false,
};

/**
 * Login request configuration
 * Maintains compatibility with existing loginRequest pattern
 */
export const loginRequest = {
  authorizationParams: {
    scope: window._env_.REACT_APP_AUTH0_SCOPE,
  },
};

/**
 * Get the post logout redirect URL
 * Defaults to the current origin if not specified
 */
export const getPostLogoutRedirectUri = () => {
  return window._env_.REACT_APP_POST_LOGOUT_URL 
    ? `${window.location.origin}${window._env_.REACT_APP_POST_LOGOUT_URL}`
    : window.location.origin;
};